<template>
	<v-dialog v-model="dialog" max-width="300px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-delete</v-icon>
					</template>
					<span>delete model</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title justify="center">
				<span class="subtitle-1">Would you like to delete the 
					<p><span class="accentColor">{{ this.model.model }}</span>?</p>
				</span>
			</v-card-title>
			<v-card-text>
				If this trademark has only 1 model, you will delete model and trademark!!
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					No
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					@click="deletingParams()"
					>Yes
				</v-btn>
				
			</v-card-actions>
		</v-card>
		<div v-else class="text-xs-center">
			<v-progress-circular
				indeterminate
				:size="100"
				:width="4"
				color="1A237E">
			</v-progress-circular>
		</div>
	</v-dialog>
</template>

<script>
	export default {
		props: ['brand', 'model', 'gameId', 'round'],
		data () {
			return	{
				dialog: false
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}
		},
		methods: {

			deletingParams () {

				//delete new upgraded model & change parent model parameter				
				if (this.brand.models.length < 2) {
					this.deleteBrand()
				}
				else {
					const parentId = this.model.parentModel
					if (parentId) {
						const parentModel = this.brand.models.find(mod => mod.modelId === parentId)
							
						parentModel.modelId = parentId
						parentModel.availabletill = 12

						this.changeModel(parentModel)
						.then(() => {
							this.deleteModel()
						})
					}
					else {
						this.deleteModel()
					}
					
				}
			},
			async deleteModel () {

				const models = {}

				this.brand.models.forEach(mod => {
					if (mod.modelId !== this.model.modelId) {
						const modelId = mod.modelId
						delete mod.modelId
						models[modelId] = mod
					}
				})
				try {
					const id = this.brand.id
					await this.$store.dispatch('deleteModel', {
						id: id,
						models: models,
						gameId: this.gameId,
						round: this.round
					})
					this.closeDialog ()				
				}
				catch (error) {
					throw error
				}
			},
			async deleteBrand () {

				try {
					const id = this.brand.id
					await this.$store.dispatch('deleteBrand', {
						id: id,
						gameId: this.gameId,
						round: this.round
					})
					this.closeDialog ()				
				}
				catch (error) {
					throw error
				}
			},
			async changeModel (model) {
				try {
					
					await this.$store.dispatch('changeModel', {
						brandId: this.brand.id,
						gameId: this.gameId,
						round: this.round,
						model: model
					})		
				}
				catch (error) {
					throw error
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
			}
		}
	}
</script>
